import { AXIS_LABEL_RADIUS_PX } from "../constants";
import { roundedRectPath } from "../text/roundedRect";

/**
 * Label on an axis: a rounded rectangle with one line of text, vertically
 * centred (crosshair labels, po-chart-visual-spec.md §12.7).
 *
 * @param {object} textLayer
 * @param {object} label
 * @param {{ x: number, y: number, width: number, height: number }} label.rect - CSS px
 * @param {string} label.text
 * @param {number} label.textX - x of the text anchor
 * @param {CanvasTextAlign} label.align
 * @param {{ font: string, background: string, color: string }} style - CSS colours
 */
export const drawAxisLabel = (
  textLayer,
  { rect, text, textX, align },
  { font, background, color },
) => {
  const { context } = textLayer;

  roundedRectPath(context, rect, AXIS_LABEL_RADIUS_PX);
  context.fillStyle = background;
  context.fill();
  textLayer.drawText(text, textX, rect.y + rect.height / 2, { font, color, align });
};
